import React, { useState } from "react";
import { TabContext, TabPanel } from "@mui/lab";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import styled from "@emotion/styled";
import MainContainer from "../../components/Container/MainContainer";
import BlockContainer from "../../components/Container/BlockContainer";
import BaseImage from "../../components/BaseImage";

import FamilyMemberProfileTab from "../../components/FamilyMemberProfileTab";
import FamilyMemberMedicalReportsTab from "../../components/FamilyMemberMedicalReportsTab";
import FamilyMemberNonMedicalReportsTab from "../../components/FamilyMemberNonMedicalReportsTab";
import BaseLink from "../../components/BaseLink";

const TABS = [
  {
    label: 'Profile',
    value: 'profile'
  },
  {
    label: 'Medical Reports',
    value: 'medical-reports'
  },
  {
    label: 'Non-medical Reports',
    value: 'non-medical-reports'
  },
]

const FamilyMemberDetail = () => {
  const [selectedOptionType, setSelectedOptionType] = useState(TABS[0].value)
  
  return (
    <MainContainer>
      <BlockContainer
        sx={{
          position: 'relative',
        }}
      >
        <BaseLink to='/family'>
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              mt: '8px',
              mb: '24px',
              cursor: 'pointer'
            }}
          >
            <ArrowBackIcon 
              sx={{
                fontSize: '16px',
                color: 'primary.black',
                mr: '8px'
              }}
            />
            <Typography variant="body" color='primary.black'>
              Back to Family / Pedigree
            </Typography>
          </Box>
        </BaseLink>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: '20px 0px'
          }}
        >
          <BaseImage
            sx={{
              minWidth: '80px',
              height: '80px',
            }}
            sximage={{
              borderRadius: '50%'
            }}
            src={'//ssl.gstatic.com/accounts/ui/avatar_2x.png'}
            alt='profile-avatar'
          />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '100%',
              flexGrow: 1,
              ml: '16px'
            }}
          >
            <Typography variant="h1" color='primary.black'>
              Maybelline Johansen
            </Typography>
            <Typography variant="h3" color='primary.darkGray'>
              Daughter
            </Typography>
            <Box
              sx={{
                display: 'inherit'
              }}
            >
              <Typography
                variant="subText"
                sx={{
                  color: 'primary.black',
                  backgroundColor: 'primary.yellow',
                  padding: '1px 7px 1px 7px',
                  borderRadius: '4px',
                }}
              >
                Family Administrator
              </Typography>
            </Box>
          </Box>
        </Box>
        <TabContext value={selectedOptionType}>
          <Box sx={{
            px: '16px'
          }}>
            <Tabs
              value={selectedOptionType}
              onChange={(e, value) => setSelectedOptionType(value)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="notification API tabs"
              sx={{
                borderBottom: 1,
                borderColor: 'primary.lightGray',
                '& .MuiTabs-indicator': {
                  display: 'flex',
                  justifyContent: 'center',
                  backgroundColor: 'primary.mainBlue',
                },
                '& .MuiTabs-indicatorSpan': {
                  width: '100%',
                  backgroundColor: '#635ee7',
                },
              }}
            >
              {TABS.map((tab => (
                <StyledTab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  sx={{
                    color: 'primary.darkGray',
                    fontSize: '15px',
                    textAlign: 'left',
                    fontWeight: 500
                  }}
                />
              )))}
            </Tabs>
          </Box>
          <Box
            className='notification-dropdown-scroll'
            sx={{
              height: '100%',
              overflowY: 'auto',
              // pr: '10px',

              '& .MuiTabPanel-root': {
                padding: 0
              }
            }}
          >
            <TabPanel value="profile">
              <FamilyMemberProfileTab />
            </TabPanel>
            <TabPanel value="medical-reports">
              <FamilyMemberMedicalReportsTab />
            </TabPanel>
            <TabPanel value="non-medical-reports">
              <FamilyMemberNonMedicalReportsTab />
            </TabPanel>
          </Box>
        </TabContext>
      </BlockContainer>
    </MainContainer>
  );
};

const StyledTab = styled(Tab)({
  "&.Mui-selected": {
    color: "#5B87EF",
  },
});

export default FamilyMemberDetail;
